import { render, staticRenderFns } from "./PageEditorSiteTree.vue?vue&type=template&id=5bca37e4&scoped=true"
import script from "./PageEditorSiteTree.vue?vue&type=script&lang=js"
export * from "./PageEditorSiteTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca37e4",
  null
  
)

export default component.exports